<template>
  <div class="chips-bar bg-white user-select-none">
    <v-chip-group
      :model-value="value"
      mandatory
    >
      <v-chip
        v-for="item in items"
        :key="item.type"
        class="chips-bar__chip rounded-pill text-body-1 text-sm-h5"
        variant="outlined"
        :class="{ 'v-chip--selected chips-bar__chip_active': value === item.type }"
        :value="item.type"
        @click="handleClickItem(item.type)"
      >
        {{ item.name }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { RouteRecordName } from 'vue-router'

defineProps({
  value: { type: String as PropType<RouteRecordName | null>, default: 'index' },
  items: { type: Array as PropType<Array<{ type: string, name: string }>>, default: () => [] },
})

const emit = defineEmits(['click:item', 'input'])

function handleClickItem(item: string) {
  emit('click:item', item)
  emit('input', item)
}
</script>

<style lang="scss">
@use '@/assets/vuetify/settings';
@use 'sass:map';

.chips-bar {
  z-index: 1;
  position: relative;
  padding: 0;

  &__chip {
    border-color: $t-ui-bg-gray-80 !important;
    padding: 10.5px !important;

    @media #{map.get(settings.$display-breakpoints, 'sm-and-up')} {
      padding: 24px !important;
    }

    &:last-child {
      margin-right: 0 !important;
    }

    &_active {
      color: $t-primary !important;
      border-color: $t-primary !important;
      background-color: $t-ui-bg-gray-0 !important;
    }
  }
}
</style>
